import { IUser } from './user.model';
import { ISipCause } from './sip-cause.model';
import { IFundraiser } from '@models/fundraiser.model';
import { IOrder } from './order.model';

export interface IPayConfig {
  amount: number;
  cartAmount: number;
  sipAmount: number;
  sipCartAmount: number;
  currency: string;
  isSip: boolean;
  disableAction: boolean;
  loading: boolean;
  donateBtnLabel: string;
  tipAmount: number;
  tipPerc: number;
  sipTipAmount: number;
  SipTipPerc: number;
  gCaptchaToken: string;
  userData?: IUser;
  cartPayload?: ICartPayload;
  cartResponse?: ICartResponse;
  sipCartResponse?: ICartResponse;
  contributeResponse?: IContribute;
  contributeSipResponse?: IContribute;
  optionsResponse?: any;
  orderPayload?: IOrderPayload;
  orderResponse?: IOrder;
  sendPayoad?: any;
  sendResponse?: any;
}

export const DEFAULT_PAY_CONFIG: IPayConfig = {
  amount: 0,
  cartAmount: 0,
  sipAmount: 0,
  sipCartAmount: 0,
  currency: 'INR',
  isSip: false,
  loading: false,
  disableAction: false,
  donateBtnLabel: '',
  tipAmount: 0,
  tipPerc: 0,
  sipTipAmount: 0,
  SipTipPerc: 0,
  gCaptchaToken: ''
}

export interface ISendPayload {
  order_id: string;
  return_url: string;
  token?: string;
  token_1?: string;
  save_card?: any;
  customer_id: string;
  account_no?: string;
  ifsc_code?: string;
  bank_code?: string;
  bank_name?: string;
  auth_mode?: string;
  payment_method_change?: number | string;
  showError?: 'false';
}

export interface ICard {
  card_type: string;
  cvv_length: any[];
  gaps: any[];
  supported_lengths: any[];
  length_valid: boolean;
  luhn_valid: boolean;
  max_length: number;
  valid: boolean;
}
export interface ICartProduct {
  id: number;
  name: string;
  per_unit_amount: number;
  unit_count: number;
}

export interface ICartPayload {
  campaign_id: number;
  currency: string;
  device: string;
  donated_amount: number;
  donor_name: string;
  donor_email: string;
  donor_extension: string;
  donor_phone: string | number;
  campaign_products?: ICartProduct[],
  is_anonymous?: '1' | '0';
  donor_pincode?: number;
  donor_country?: string;
  donor_city?: string;
  donor_address?: string;
  'g-recaptcha-response'?: string;
  tip_amount?: number;
  tip_amount_perc?: number;
  skipmin?: boolean;
  pan?: string;
  passport?: string;
  reward_id?: string | number;
  indian?: boolean;
  coupon_code?: string | number;
  bulkdonation?: any;
  bulkAmount?: number;
  recurring?: 1;
  ngo_sip?: 1;
  cause_amount?: number;
  sip_cause?: ISipCause[];
  guest?: 0 | 1;
  split?: boolean;
  vendor?: string;
  plan?: string;
  plan_id?: string | number;
  critical_illness?: number;
  pledge_more?: 1;
  accessToken?: any;
  wallet_to_autopay?: 1;
  transaction_type?: string;
  wallet_recharge?: 1;
  multicause?: any;
  showError?: 'false';
}

export interface ICartResponse {
  cart?: ICart;
  campaign?: ICartCampaign;
  login?: boolean;
  token?: string;
  user?: any;
}

export interface ICartCampaign {
  action_at?: any;
  address_1?: string;
  address_2?: string;
  address_3?: string;
  amount_requested?: number;
  beneficiary?: any;
  cause_id?: number;
  cause_id_old?: number;
  corporate_entity_details_id?: number;
  creation_date?: string;
  creator_entity_details_id?: number;
  custom_tag?: string;
  display_type_self?: any;
  end_date?: string;
  entity_details_id?: number;
  event_entity_details_id?: number;
  id?: number;
  ketto_commission?: string;
  manager_id?: number;
  only_foreign?: {
    entity_details_id?: number;
    entity_type?: string;
    info_1?: string;
    info_2?: string;
    info_type?: string;
  }
  owner?: {
    access_url?: string;
    address_1?: string;
    address_2?: string;
    address_3?: string;
    age?: string;
    city?: string;
    creation_time?: string;
    disable_foreign_donation?: number;
    entity_type?: string;
    fname?: string;
    full_name?: string;
    gender?: string;
    id?: number;
    lname?: string;
    no_80g?: boolean;
    pincode?: string;
    profileIncomplete?: boolean;
    status_flag?: number;
    tax_benefit?: boolean;
    user_details_id?: number;
    website_1?: string;
    website_2?: string;
  }
  parent_cause_id?: number;
  parent_entity_details_id?: number;
  priority_self?: number;
  start_date?: string;
  status_flag?: number;
  submitted_at?: string;
  sucess_story_flag?: number;
  title?: string;
  updated_at?: string;
  user_details_id?: number;
  timestamp?: number;
}

export interface ICart {
  campaign_id?: number;
  currency?: string;
  donated_amount?: number;
  donated_amount_inr?: number;
  donor_address?: string;
  donor_email?: string;
  donor_entity_details_id?: number;
  donor_name?: string;
  donor_phone?: number;
  donor_pincode?: number;
  donor_country?: string;
  donor_city?: string;
  id?: number;
  is_anonymous?: number;
  pan?: string;
  recurring?: boolean;
  status_flag?: boolean;
  selected_currency?: string;
  donated_amount_local?: string;
  donor_extension?: string;
  indian?: any;
  tip_amount?: number;
  tip_amount_perc?: number;
  tip_amount_inr?: number;
  skipCardPrefil?: boolean;
  reward_id?: boolean;
  sip_cause?: string;
  sip_cause_str?: string;
  slabs?: Array<number>;
  bulkdonation?: any;
  timestamp?: number;
  plan?: string;
  vendor?: string;
  device?: string;
  resetQR?: boolean;
  onlySipCauseArr?: string[];
  plan_id?: number;
  supportFee?: any;
  showKCart?: boolean;
  campaign_products?: ICartProduct[];
  ngo_sip?: number;
  initPossition?: string;
}

export interface IOrderPayload {
  ab_testname?: string;
  ab_value?: string;
  auto_pay_m1?: string | number;
  bin?: string;
  bulkdonation?: any;
  campaign_id?: number;
  campaign_products?: ICartProduct[];
  card_cvv_fill?: string;
  card_month_fill?: string;
  card_name_fill?: string;
  card_no?: number;
  card_number_fill?: string;
  card_year_fill?: string;
  cart_id?: number;
  cause_amount?: number;
  cause_id?: string | number;
  checkout_type?: 'standard' | 'custom';
  coupon_code?: string;
  critical_illness?: number;
  customer_id?: number | string;
  donor_pincode?: number | string;
  frequency?: number;
  frequency_term?: string | number;
  gateway?: string;
  is_indian?: true | '0';
  is_multi_patient_campaign?: any;
  ketto_wallet?: 1;
  mode?: string;
  mode_value?: string;
  month_interval?: number;
  multicause?: any;
  ngo_sip?: 1;
  oneTapPay?: boolean;
  page_type?: string;
  payment_gateway?: string;
  plan?: string;
  plan_id?: string | number;
  repeat_donor?: 1;
  sip_cause?: ISipCause[];
  stripeSwitch?: boolean;
  subscription_id?: number;
  support_campaign_id?: number;
  tenure?: number;
  transaction_type?: string;
  vendor?: string;
  vpa?: string;
  wallet_to_autopay?: 1;
}

export interface IDonor {
  access_url: string;
  address_1: string;
  address_2: string;
  address_3: string;
  age: string;
  city: string;
  disable_foreign_donation: number;
  display_type: string;
  email: string;
  entity_type: string;
  extension: string;
  fname: string;
  full_name: string;
  name: string;
  gender: string;
  id: number;
  is_subscribed: number;
  last_communication_date: string;
  lname: string;
  no_80g: boolean;
  phone_1: string;
  phone_2: string;
  pincode: string;
  priority: string;
  status_flag: number;
  tax_benefit: boolean;
  updation_time: string;
  user_details_id: number;
  user_role: string;
  username: string;
  activation: {
    creation_date: string,
    order_details_id?: string
  };
  comments: any[];
}

export interface IContribute {
  default_amount: number;
  min_donation: number;
  selected_currency: string;
  slabs: number[];
  supported_currency: any[];
  campaign?: IFundraiser;
  address?: boolean;
  anonymous?: boolean;
  ask_citizenship?: boolean;
  ask_email?: boolean;
  ask_pan?: boolean;
  ask_passport?: boolean;
  checkout_type?: string;
  cover_txn_cost_perc?: number;
  is_anonymous?: boolean;
  mandate_fee?: number;
  ngo_sip_campaign?: boolean;
  only_foreign?: boolean;
  only_inr?: boolean;
  pan_required_amount?: number;
  pan_validation_amount?: number;
  pincode?: boolean;
  rewards?: IRewards[];
  show_popular?: boolean;
  sip_cause?: string;
  stripe_link_enabled?: boolean;
  support_fee_perc?: number;
  insurance_under_18?: boolean;
  timestamp?: number;
  payment_methods?: {
    gateway?: string;
    payment_gateway?: string;
    settings?: {
      paypal?: { client_id?: string };
      stripe?: { key?: string }
    }
  };
  insurance?: {
    amount_requested?: number;
    cause_id?: number;
    creator_entity_details_id?: number;
    id?: number;
    raised?: number;
    status_flag?: number;
  };
}

export interface IRewards {
  active_backers_count: number;
  amount: number;
  amount_from: number;
  amount_to: number;
  amount_usd: number;
  backers: number;
  campaign_id: number;
  creation_date: string;
  descp: string;
  display_text: string;
  expected_date: string;
  id: number;
  notes: string;
  status_flag: number;
}

export interface IPayementGateway {
  gateway: string;
  options: {
    CARD: any;
    NB: any;
    TOPNB: any;
    WALLET: any;
    PAYTM: any;
    TOPWALLET: any;
    UPI: any;
    PREVIOUSPAYMENTGATEWAY?: any;
    REWARD: any;
    ATM_CARD: any;
    TOPUPI: any;
    RECOMMENDED_VPA?: string;
    payment_offers?: any;
  };
  setting: any;
  doNotSetOption?: boolean;
}

export interface IOptions {
  name: string;
  icon: string;
  route?: string;
  data: any;
}


export interface IPaymentConfig {
  currency?: string;
  enable_sip_switch?: boolean;
  is_sip?: boolean;
  mini_story?: boolean;
  origin?: string;
  sip_contribute_details?: IContribute;
  bypass_for_min_cart_only?: boolean;
  cart_response?: ICart;
  enable_min_cart_lead?: boolean;
}

export const PAYMENT_DEFAULT_CONFIG: IPaymentConfig = {
  enable_sip_switch: false,
  is_sip: false
}